import Vue from 'vue';

function clearUser(state) {
	Vue.set(state, 'token', null);
	Vue.set(state, 'user', null);
}

function setToken(state, token) {
	Vue.set(state, 'token', token);
}

function setUser(state, user) {
	Vue.set(state, 'user', user);
}

function isEmployee(state, flagAdmin) {
	const flag = typeof flagAdmin === 'string' ? Number(flagAdmin) : flagAdmin;
	Vue.set(state.user, 'isEmployee', !flag);
}

function showSnackBar(state, snackbar) {
	Vue.set(state.appConfig, 'snackbar', snackbar);
}

function toggleLoading(state, value) {
	Vue.set(state.appConfig, 'isLoading', value);
}

function UPDATE_POLL_PROGRESS(state, number) {
	Vue.set(state.pollData, 'progress', state.pollData.progress + number);
}

function RESET_POLL_PROGRESS(state) {
	Vue.set(state.pollData, 'progress', 0);
}

function SET_SIDE_BAR_ROUTES(state, routes) {
	Vue.set(state, 'sideBarRoutes', routes);
}

const methods = {
	clearUser,
	isEmployee,
	setToken,
	setUser,
	showSnackBar,
	toggleLoading,
	RESET_POLL_PROGRESS,
	SET_SIDE_BAR_ROUTES,
	UPDATE_POLL_PROGRESS,
};

export default methods;



// WEBPACK FOOTER //
// ./src/store/mutations.js